import { Component, DoCheck, signal } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { PurchaseProposalProductLedgerComponent } from '../purchase-proposal-product-ledger/purchase-proposal-product-ledger.component';

/**
 * Formly type of the product page (Artikel › Einkauf › Bestelldispo): the product's article account, information only.
 * The formly types load at startup – the account, its chart and the dispo's services come in their own chunk, once
 * the tab is shown (`@defer`).
 */
@Component({
  selector: 'app-formly-purchase-proposal-product-ledger',
  standalone: true,
  imports: [PurchaseProposalProductLedgerComponent],
  template: `
    @if (productId(); as id) {
      @defer (on viewport) {
        <app-purchase-proposal-product-ledger [productId]="id" [version]="version()" />
      } @placeholder {
        <div class="min-h-24"></div>
      }
    }
  `,
})
export class FormlyPurchaseProposalProductLedgerComponent extends FieldType<FieldTypeConfig> implements DoCheck {
  readonly productId = signal<string | null>(null);
  readonly version = signal<number | null>(null);

  /** The product model is replaced or updated in place by the detail page (save); signals only notify on a change. */
  ngDoCheck(): void {
    const product = this.model as { id?: string | null; version?: number | null } | undefined;
    this.productId.set(product?.id ?? null);
    this.version.set(product?.version ?? null);
  }
}
